package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ObjectiveProgressHistoryQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectByObjective(objective_id: String, mapper: (
    id: String,
    objective_id: String,
    progress: Long,
    recorded_at: Long,
  ) -> T): Query<T> = SelectByObjectiveQuery(objective_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun selectByObjective(objective_id: String): Query<Objective_progress_history> =
      selectByObjective(objective_id) { id, objective_id_, progress, recorded_at ->
    Objective_progress_history(
      id,
      objective_id_,
      progress,
      recorded_at
    )
  }

  public fun <T : Any> selectLatestForObjective(objective_id: String, mapper: (
    id: String,
    objective_id: String,
    progress: Long,
    recorded_at: Long,
  ) -> T): Query<T> = SelectLatestForObjectiveQuery(objective_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun selectLatestForObjective(objective_id: String): Query<Objective_progress_history> =
      selectLatestForObjective(objective_id) { id, objective_id_, progress, recorded_at ->
    Objective_progress_history(
      id,
      objective_id_,
      progress,
      recorded_at
    )
  }

  public fun insert(
    id: String,
    objective_id: String,
    progress: Long,
    recorded_at: Long,
  ) {
    driver.execute(-1_745_417_663, """
        |INSERT INTO objective_progress_history(id, objective_id, progress, recorded_at)
        |VALUES (?, ?, ?, ?)
        """.trimMargin(), 4) {
          bindString(0, id)
          bindString(1, objective_id)
          bindLong(2, progress)
          bindLong(3, recorded_at)
        }
    notifyQueries(-1_745_417_663) { emit ->
      emit("objective_progress_history")
    }
  }

  public fun deleteByObjective(objective_id: String) {
    driver.execute(-407_213_201,
        """DELETE FROM objective_progress_history WHERE objective_id = ?""", 1) {
          bindString(0, objective_id)
        }
    notifyQueries(-407_213_201) { emit ->
      emit("objective_progress_history")
    }
  }

  private inner class SelectByObjectiveQuery<out T : Any>(
    public val objective_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective_progress_history", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective_progress_history", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_046_720_382, """
    |SELECT objective_progress_history.id, objective_progress_history.objective_id, objective_progress_history.progress, objective_progress_history.recorded_at FROM objective_progress_history
    |WHERE objective_id = ?
    |ORDER BY recorded_at
    """.trimMargin(), mapper, 1) {
      bindString(0, objective_id)
    }

    override fun toString(): String = "ObjectiveProgressHistory.sq:selectByObjective"
  }

  private inner class SelectLatestForObjectiveQuery<out T : Any>(
    public val objective_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("objective_progress_history", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("objective_progress_history", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_259_794_629, """
    |SELECT objective_progress_history.id, objective_progress_history.objective_id, objective_progress_history.progress, objective_progress_history.recorded_at FROM objective_progress_history
    |WHERE objective_id = ?
    |ORDER BY recorded_at DESC
    |LIMIT 1
    """.trimMargin(), mapper, 1) {
      bindString(0, objective_id)
    }

    override fun toString(): String = "ObjectiveProgressHistory.sq:selectLatestForObjective"
  }
}
